/* const lista: RascEnderecoComplementarModel[] = [];
         estabelecimento.identificacao.enderecosComplementares.forEach((item) => {
             lista.push({
                 bairro: item.bairro,
                 cep: item.cep,
                 codigo: item.id,
                 dataAtivacao: item.dataAtivacao,
                 dataDesativacao: item.dataDesativacao,
                 dddFax: '',
                 dddTelefone: '',
                 email: '',
                 estabelecimento: estabelecimento.codigoUnidade,
                 fax: '',
                 municipio: item.municipio,
                 ibgeMunicipio: item.codigoIbgeMunicipio,
                 ibgeUf: item.siglaUf,
                 identificacao: item.identificacao,
                 nomeComplemento: item.complemento,
                 nomeLogradouro: item.logradouro,
                 numero: item.numero,
                 sequencial: '',
                 telefone: item.telefone,
                 tipoLogradouro: '',
                 usuario: '',
                 // tslint:disable-next-line:max-line-length
                 // tslint:disable-next-line:max-line-length
                 // tslint:disable-next-line:max-line-length
                 servicosVinculados: this.montarServicosEnderecoComplementar(estabelecimento.cnes, estabelecimento.codigoUnidade, item.servicosVinculados),
             });
         });
         if (lista.length > 0) {
             return lista;
         } else {
             return null;
         }*/import { EstabelecimentoModel } from '../../estabelecimento.model';
import { Util } from '../../../../utils/util';

export class RascIdentificacaoPrincipalModel {
    cnes: string;
    cnpj: string;
    cpf: string;
    id: string;
    nomeFantasia: string;
    statuscodigo: string;
    statusdescricao: string;
    usuarioAlteracao: string;
    usuarioCriacao: string;

    constructor(estabelecimento: EstabelecimentoModel) {
        this.cnes = (estabelecimento.identificacao.principal ? estabelecimento.identificacao.principal.cnes : '');
        this.cnpj = (estabelecimento.identificacao.principal ? Util.removeMascaraCpfCnpj(estabelecimento.identificacao.principal.cnpj) : '');
        this.cpf = (estabelecimento.identificacao.principal ? Util.somenteNumeros(estabelecimento.identificacao.principal.cpf) : '');
        this.id = (estabelecimento.identificacao.principal ? estabelecimento.identificacao.principal.id : '');
        this.nomeFantasia = (estabelecimento.identificacao.principal ? estabelecimento.identificacao.principal.nomeFantasia : '');
        this.statuscodigo = (estabelecimento.identificacao.principal ? estabelecimento.identificacao.principal.statuscodigo : '');
        this.statusdescricao = (estabelecimento.identificacao.principal ? estabelecimento.identificacao.principal.statusdescricao : '');
        this.usuarioAlteracao = (estabelecimento.identificacao.principal ? estabelecimento.identificacao.principal.usuarioAlteracao : '');
        this.usuarioCriacao = (estabelecimento.identificacao.principal ? estabelecimento.identificacao.principal.usuarioCriacao : '');
    }
}

export class RascunhoIdentificacaoPrincipalModel {
    bairro: string;
    cep: string;
    cnpj: string;
    codigoUf: string;
    codigoUnidade: string;
    complementoEndereco: string;
    cpf: string;
    email: string;
    entidadesAdministradoras: string;
    idRascunho: string;
    latitude: string;
    logradouro: string;
    longitude: string;
    municipio: string;
    idnaturezaJuridicaMantenedora: string;
    naturezaJuridicaMantenedora: string;
    // nomeEmpresarialMantenedora: string;
    nomeFantasia: string;
    numeroEndereco: string;
    telefone: string;
    tipoEstruturaid: string;
    tipoEstrutura: string;
    codigoMunicipioIBGE: string;
    nomeEmpresarial: string;

    constructor(estabelecimento: EstabelecimentoModel) {
        const identificacaoPrincipal = estabelecimento.identificacao.identificacaoPrincipal;

        this.bairro = identificacaoPrincipal ? identificacaoPrincipal.bairro : '';
        this.cep = identificacaoPrincipal ? Util.somenteNumeros(identificacaoPrincipal.cep) : '';
        this.cnpj = identificacaoPrincipal ? Util.removeMascaraCpfCnpj(identificacaoPrincipal.cnpj) : '';
        this.codigoUf = identificacaoPrincipal ? identificacaoPrincipal.codigoUf : '';
        this.codigoUnidade = identificacaoPrincipal ? identificacaoPrincipal.codigoUnidade : '';
        this.complementoEndereco = identificacaoPrincipal ? identificacaoPrincipal.complementoEndereco : '';
        this.cpf = identificacaoPrincipal ? Util.somenteNumeros(identificacaoPrincipal.cpf) : '';
        this.email = identificacaoPrincipal ? identificacaoPrincipal.email : '';
        this.latitude = identificacaoPrincipal ? identificacaoPrincipal.latitude : '';
        this.logradouro = identificacaoPrincipal ? identificacaoPrincipal.logradouro : '';
        this.longitude = identificacaoPrincipal ? identificacaoPrincipal.longitude : '';
        this.municipio = identificacaoPrincipal ? identificacaoPrincipal.municipio : '';
        this.idnaturezaJuridicaMantenedora = identificacaoPrincipal ? identificacaoPrincipal.codigoNaturezaJuridica : '';
        this.nomeEmpresarial = identificacaoPrincipal ? identificacaoPrincipal.nomeEmpresarial : '';
        this.nomeFantasia = identificacaoPrincipal ? identificacaoPrincipal.nomeFantasia : '';
        this.numeroEndereco = identificacaoPrincipal ? identificacaoPrincipal.numeroEndereco : '';
        this.telefone = identificacaoPrincipal ? Util.somenteNumeros(identificacaoPrincipal.telefone) : '';
        this.codigoMunicipioIBGE = identificacaoPrincipal ? identificacaoPrincipal.codigoMunicipioIBGE : '';
        this.tipoEstruturaid = identificacaoPrincipal ? identificacaoPrincipal.tipoEstruturaid : '';
        this.tipoEstrutura = identificacaoPrincipal ? identificacaoPrincipal.tipoEstrutura : '';
    }
}
